import { daysOfTheWeek } from 'consts/daysOfTheWeekType/daysOfTheWeekType';

export const detectDayOfTheWeek = (day: string) => {
  return daysOfTheWeek[day];
};
